export const FrequentTimeZones = {
  UsCentral: 'US/Central',
  UsPacific: 'US/Pacific',
  UTC: 'UTC',
} as const;
